export const strict = false;

import { createStore } from "vuex";

// Modules
import auth from "./modules/auth";
import createPersistedState from "vuex-persistedstate";
import config from "@/config/app";
import errors from "./modules/errors";
import help from "./modules/help";
import cases from "./modules/cases";
import orders from "./modules/orders";
import hospitals from "./modules/hospitals";
import sendOuts from "./modules/sendOuts";
import physicians from "./modules/physicians";
import icd10Codes from "./modules/icd10Codes";
import userAccounts from "./modules/userAccounts";
import updatePassword from "./modules/updatePassword";
import profile from "./modules/profile";
import labs from "./modules/labs";
import labDocuments from "./modules/labDocuments";
import session from "./modules/session";
import insurances from "./modules/insurances";
import respiratoryFileUpload from "./modules/respiratoryFileUpload"
import rulebook from "./modules/rulebook"
import exceptionReport from "./modules/exceptionReport"
import payors from "./modules/payors"
import potentialPayers from "./modules/potentialPayers"
import logs from "./modules/logs";

const moduleNames = [
  "auth",
  "errors",
  "profile",
  "session",
  "orders",
  "help",
  "cases",
  "hospitals",
  "sendOuts",
  "physicians",
  "icd10Codes",
  "userAccounts",
  "labs",
  "updatePassword",
  "labDocuments",
  "insurances",
  "respiratoryFileUpload",
  "rulebook",
  "exceptionReport",
  "payors",
  "potentialPayers",
  "logs"
];

// Exclude very large modules from persistence to avoid localStorage quota issues
// const persistedModuleNames = moduleNames.filter(
//   (m) => !["physicians"].includes(m)
// );
const persistedModuleNames = [
  "auth",
  "profile.profileData",
  "profile.profileUpdateStatus",
  "profile.profilePicUrlForHeader",
  "profile.profileUserNameForHeader",
  "profile.profileDesignationForHeader",
  "profile.statesData",
  "session",
];

// Wrap localStorage to avoid crashing on QuotaExceededError
const safeLocalStorage = {
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.warn("Persisted state: quota exceeded; skipping save for", key);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  },
};

const store = new createStore({
  modules: {
    auth,
    profile,
    errors,
    help,
    cases,
    orders,
    hospitals,
    sendOuts,
    physicians,
    icd10Codes,
    userAccounts,
    labs,
    updatePassword,
    session,
    labDocuments,
    insurances,
    respiratoryFileUpload,
    rulebook,
    exceptionReport,
    payors,
    potentialPayers,
    logs
  },
  strict: false,
  plugins: [
    createPersistedState({
      key: config.APP_NAME + "_" + config.APP_VERSION,
      paths: persistedModuleNames,
      storage: safeLocalStorage,
    }),
  ],
  actions: {
    globalReset({ commit }) {
      moduleNames.forEach((module) => {
        commit(`${module}/reset`);
      });
      localStorage.removeItem("componentShown");
      localStorage.removeItem("versionHandled");
      // clear persisted UI search for AllCases to avoid retaining previous session input
      localStorage.removeItem("allCases_search_string");
      // also clear persisted Vuex state if needed
      try {
        localStorage.removeItem(config.APP_NAME + "_" + config.APP_VERSION);
      } catch (e) {
        console.log("Error clearing persisted state:", e);
      }
    },
  },
});

export default store;
